export default {
    meta: {
        title: '拓店宝-机会点详情'
    }
};
